import moment from 'moment';

export const formatFromToDates = (date, timeStart, timeEnd) => {
  if (timeEnd.hour() === 0 && timeEnd.minute() === 0) {
    timeEnd.set({ hour: 23, minute: 59, second: 59 });
  }

  const _fromDate = date.format('YYYY-MM-DD') + ' ' + timeStart.format('HH:mm');

  const _toDate = date.format('YYYY-MM-DD') + ' ' + timeEnd.format('HH:mm');

  const fromDate = moment(_fromDate).utc().format();
  const toDate = moment(_toDate).utc().format();

  return { fromDate, toDate };
};
